<template>
  <div class="fav-list">
    <HeadingBlock heading="Favoriten" />

    <ErrorScreen v-if="errored" />
    <LoadingScreen v-if="loading" />

    <section v-if="!loading && !errored">
      <v-container v-if="stores.length === 0">
        <v-alert type="info" text>
          <p>Du hast auf diesem Gerät noch keine Favoriten gespeichert!</p>
          <v-btn @click="navigateToNearby()" color="#2196f3" text
            >Umgebung erkunden!</v-btn
          >
        </v-alert>
      </v-container>
      <StoreList v-else v-bind:stores="stores" />
    </section>
  </div>
</template>

<script>
import favorites from "@/generics/favorites.js";

import ErrorScreen from "@/components/ErrorScreen.vue";
import LoadingScreen from "@/components/LoadingScreen.vue";
import HeadingBlock from "@/components/HeadingBlock.vue";
import StoreList from "@/components/store/StoreList.vue";

export default {
  name: "FavList",

  components: {
    ErrorScreen,
    LoadingScreen,
    HeadingBlock,
    StoreList
  },

  data: function() {
    return {
      loading: true,
      errored: false,

      stores: []
    };
  },

  methods: {
    navigateToNearby: function() {
      let cityId = this.$route.params.cityId;
      if (cityId == null) {
        cityId = localStorage.getItem(this.$localStorageKeys.CITY_ID);
      }

      if (cityId == null) {
        this.$router.push({
          name: "SelectCity"
        });
      } else {
        this.$router.push({
          name: "Nearby",
          params: {
            cityId: cityId
          }
        });
      }
    }
  },

  mounted() {
    try {
      this.axios
        .get(`${this.$apiHost}/api/v1/stores/`, {
          params: {
            storeIds: favorites.get()
          }
        })
        .then(response => (this.stores = response.data))
        .catch(() => (this.errored = true))
        .finally(() => (this.loading = false));
    } catch (e) {
      console.error(e);
    }
  }
};
</script>
